// extracted by mini-css-extract-plugin
export default {"clearcachebtn":"clearCacheBtn_clearcachebtn__AeaVE"};